import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { custodiansFetch, deleteCustodian } from 'store/actions/favouriteCustodians.action';
import { custodiansSelector } from 'store/reducers/favouriteCustodians.reducer';
import { useSelector, useDispatch } from 'react-redux';
import { Card, SliderArrowNext, SliderArrowPrev, Topography } from 'components/ui';
import Slider from 'react-slick';
import { PreloaderWrapper } from 'components/containers/PreloaderWrapper/PreloaderWrapper';
import styles from './FavoritesSection.module.scss';
import Modal from 'components/modals/Modal/Modal';
import largeStart from 'assets/images/big-start.png';
import { Icon } from '../../../components/ui';

export type FavoritesSectionProps = {
  className?: string;
  onClick?: (provider: any) => void;
  withDelete?: boolean;
  isFormRequest?: boolean
};

const settings = {
  arrows: true,
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  useCSS: true,
  nextArrow: <SliderArrowNext slidesToShow={3} />,
  prevArrow: <SliderArrowPrev slidesToShow={3} />,
};

const mobileSettings = {
  arrows: true,
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  useCSS: true,
  nextArrow: <SliderArrowNext slidesToShow={1} />,
  prevArrow: <SliderArrowPrev slidesToShow={1} />,
};

export const FavoritesSection: React.FC<FavoritesSectionProps> = ({ onClick, withDelete, isFormRequest }) => {
  const dispatch = useDispatch();
  const { custodians, isFetching, isUpdating } = useSelector(custodiansSelector);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [custodianId, setCustodianId] = useState<number>();
  // const custodians = [...]; // Your array of custodians
  const itemsPerPage = 5; // Number of items to display per page
  const [currentPage, setCurrentPage] = useState(1);
  const numPages:any = Math.ceil(custodians.length / itemsPerPage);
  
  function handlePageChange(newPage: React.SetStateAction<number>) {
    setCurrentPage(newPage);
  }

  useEffect(() => {
    dispatch(custodiansFetch(isFormRequest));
  }, [dispatch]);

  function handleDeleteCastodian(id: number) {
    dispatch(deleteCustodian(id));
    setIsOpen(false);
  }

  function handleConfirmDelete(id: number) {
    setCustodianId(id);
    setIsOpen(true);
  }

  function renderCards() {
    const cardsPerPage = 5;
    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = currentPage * cardsPerPage;
    const visibleCards = custodians.slice(startIndex, endIndex);

    return visibleCards.map((item, i) => (
      <Card.Favorite
        className={'my-3'}
        key={item.id}
        data={item}
        onClick={() => onClick && onClick(item)}
        withDelete={withDelete}
        handleDelete={handleConfirmDelete.bind(null, item.id)}
      />
    ));
  }

  function renderFavouriteCastodians() {
    if (isFetching || isUpdating) return <PreloaderWrapper />;
    else if (withDelete)
      return (<div className='row mb-5'>{renderCards()}</div>)

    else
    if(custodians.length >= 1){
      return (<>
    
    <div>
      <div className="d-none d-md-block mb-5">
        {renderCards()}
      </div>

      {/* Pagination controls */}
      <div className='fav_custodian_pagination'>
        {currentPage > 1 && (
          <span onClick={() => handlePageChange(currentPage - 1)}>  <Icon name="arrow-left" className={styles.icon} /></span>
        )}

        <ul className="pagination">
          {Array.from({ length: numPages }).map((_, page) => (
            <li key={page} className={page + 1 === currentPage ? 'active' : ''}>
              <button onClick={() => handlePageChange(page + 1)}>{page + 1}</button>
            </li>
          ))}
        </ul>

        {currentPage < numPages && (
          <span onClick={() => handlePageChange(currentPage + 1)}> <Icon name="arrow-right" className={styles.icon} /></span>
        )}
      </div>
    </div>
        {/* <div className='d-md-none mb-5'>
          <Slider {...mobileSettings}>{renderCards()}</Slider>
        </div> */}
      </>)
    } else{
      return (<>
    
        <div className='no-favourite-providor'>
          <div className='star_big'><img src={largeStart} /></div>
          <p className='p2'>You don’t have a Favorite Provider right now. Please add one from the Provider Directory <br/>Search while creating a Record or Form Request.</p>
          <div className='action_btn'>
            <a href='/p/record-request/provider' className='btn_request_create'>Request Records</a>
            <a href='/p/form-request/provider' className='btn_request_create'>Request Forms</a>
          </div>
        </div>
        {/* <div className='d-md-none mb-5'>
          <Slider {...mobileSettings}>{renderCards()}</Slider>
        </div> */}
      </>)
    }
  }

  return (
    <div className={clsx(styles['slider-wrapper'], { [styles['will-slide']]: custodians.length > 3 }, withDelete ? 'w-100 p-3' : '')} style={{ maxWidth: withDelete ? '100%' : '90%' }}>
      {custodians.length ? (<div>
        <Topography.H2>Favorite Providers</Topography.H2>
        <p>Here you can select one of your favorite providers to start a record or form request. You can remove a providers from favorites by clicking on the star icon</p>
      </div>) : null}
      <br/>
      {renderFavouriteCastodians()}
      <Modal
        name="custodian"
        isOpen={isOpen}
        handleOk={() => custodianId && handleDeleteCastodian(custodianId)}
        handleClose={() => setIsOpen(false)}
        title="Are you sure you’d like to remove this custodian from favorite custodians list?"
        okBtnName='Yes, delete'
        cancelBtnName='No, cancel'
      />
    </div>
    
  );
};
